import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { CurrentLang, CurrentTheme } from "common";

// Use normal CSS as the modal cannot be styled in the normal way
import "./MagstimModal.css";

class MagstimModalDateOFBirth extends React.Component {

    constructor() {
        super();

        this.state = {
            isOpen: false,
            message: "",
            title: "",
            positiveButtonText:CurrentLang().message_box_OK,
            negativeButtonText:CurrentLang().message_box_cancel,
            callBack:undefined
        };

        this._dobPicker = React.createRef();
    }

    show = (title, message, positiveButtonText, negativeButtonText, callBack) => {

        if(positiveButtonText === undefined){
            positiveButtonText = CurrentLang().message_box_OK;
        }

        this.setState(
            {
                isOpen: true,
                message: message,
                title: title,
                positiveButtonText:positiveButtonText,
                negativeButtonText:negativeButtonText,
                callBack:callBack
            }
        )
    }

    hide = () => {
        this.setState(
            {
                isOpen: false
            }
        )
    }

    setTitleAndMessage = (title, message) => {
        this.setState(
            {
                message: message,
                title: title
            }
        )
    }

    positiveButtonClick = () => {
        this.toggle();

        if(this.state.callBack !== undefined){
            this.state.callBack(this.state.positiveButtonText, this._dobPicker.current.value);
        }
    }

    negativeButtonClick = () => {
        this.toggle();

        if(this.state.callBack !== undefined){
            this.state.callBack(this.state.negativeButtonText, this._dobPicker.current.value);
        }
    }

    toggle = () => {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )
    }

    render() {

        var negativeButton;

        if(this.state.negativeButtonText !== undefined){
            negativeButton = <Button color="secondary" onClick={this.negativeButtonClick}>{this.state.negativeButtonText}</Button>
        }

        return (
            <div>
                <Modal isOpen={this.state.isOpen} toggle={this.toggle} contentClassName="magstim-modal">
                    <ModalHeader toggle={this.toggle} className="w-100">
                        <Row>
                            <Col sm="2">
                                <i className="modal-icon fas fa-exclamation-triangle fa-1x"></i>
                            </Col>
                            <Col>
                                <div className="modal-header-title col-centered">
                                {this.state.title}
                                </div>
                            </Col>
                        </Row>
                        
                    </ModalHeader>
                    <ModalBody>
                        {this.state.message}

                        <InputGroup size={CurrentTheme().ControlSize} className="p-4">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{CurrentLang().edit_patient_dob_name_label}</InputGroupText>
                            </InputGroupAddon>
                            <Input type="date" name="DOB" innerRef={this._dobPicker}/>
                        </InputGroup>

                    </ModalBody>
                    <ModalFooter>
                        {negativeButton}
                        <Button color="primary" onClick={this.positiveButtonClick}>{this.state.positiveButtonText}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default MagstimModalDateOFBirth;